import { base, onDarkBase } from "@biom3/design-tokens";
import type { Theme } from "@mui/material";

export default function getDialogOverrides(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: "none",
          borderRadius: 16,
          boxShadow: base.shadow[500],
          // Responsive fullscreen on mobile
          [`@media (max-width:${theme.breakpoints.values.sm}px)`]: {
            width: "100vw",
            height: "100vh",
            maxWidth: "100%",
            maxHeight: "100%",
            margin: 0,
            borderRadius: 0,
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          overflowY: "auto",
          scrollbarWidth: "thin", // Firefox
          scrollbarColor: `${onDarkBase.color.text.body.secondary} ${onDarkBase.color.neutral[1000]}`,
          msOverflowStyle: "-ms-autohiding-scrollbar",
          "&::-webkit-scrollbar": {
            width: "8px",
            backgroundColor: onDarkBase.color.neutral[1000],
          },
          "&::-webkit-scrollbar-thumb": {
            borderRadius: "4px",
            backgroundColor: onDarkBase.color.text.body.secondary,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: onDarkBase.color.text.body.primary,
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: "4px",
            backgroundColor: onDarkBase.color.neutral[1000],
          },
          overscrollBehavior: "contain",
          WebkitOverflowScrolling: "touch",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...base.text.heading.medium.regular,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          "& > :not(:first-of-type)": {
            marginLeft: theme.spacing(2),
          },
        },
      },
    },
  };
}
